module.exports = `<link rel="stylesheet" href="https://www.juhe.cn/css/v7/headerFooter/footer-white2.css?_t=1574754268468"/><div class="footer-help">
<div class="footer-help-btn">
  <i class="iconfont icon-lianxizixun"></i>
  <span>联系</span>
  <span class="dot"></span>
  <span>咨询</span>
</div>
<div class="footer-help-top">
  <i class="iconfont icon-fanhuidingbu"></i>
  <!--[if lt IE 9]>
  <span>顶部</span>
  <![endif]-->
</div>
<div class="footer-help-container">
  <ul class="help-list">
    <li>
      <a class="clearfix click-report-log" log-data="area=400001&index_id=300003&action_type=11"
         href="https://www.juhe.cn/contact" target="_blank" rel="noopener noreferrer">
        <div class="help-icon">
          <i class="iconfont icon-lianxidianhua"></i>
        </div>
        <div class="help-text">
          <div class="help-title">联系电话</div>
          <div class="help-phone">400-882-7715</div>
        </div>
      </a>
    </li>
    <li>
      <a class="clearfix click-report-log" log-data="area=400001&index_id=300016&action_type=11"
         href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDA3NjA2NV80ODI3NzdfODAwMDc2MDY1XzJf" target="_blank" rel="noopener noreferrer">
        <div class="help-icon">
          <i class="iconfont icon-zaixianzixun"></i>
        </div>
        <div class="help-text">
          <div class="help-title">在线咨询</div>
          <div class="help-desc">QQ在线响应及时</div>
        </div>
      </a>
    </li>
    <li>
      <a class="clearfix click-report-log" log-data="area=400001&index_id=300009&action_type=11"
         href="https://www.juhe.cn/workOrder" target="_blank" rel="noopener noreferrer">
        <div class="help-icon">
          <i class="iconfont icon-gongdanguanli"></i>
        </div>
        <div class="help-text">
          <div class="help-title">工单管理</div>
          <div class="help-desc">专业解答产品疑问</div>
        </div>
      </a>
    </li>
    <li>
      <a class="clearfix click-report-log" log-data="area=400001&index_id=300008&action_type=11"
         href="https://www.juhe.cn/qa" target="_blank" rel="noopener noreferrer">
        <div class="help-icon">
          <i class="iconfont icon-changjianwenti"></i>
        </div>
        <div class="help-text">
          <div class="help-title">常见问题</div>
          <div class="help-desc">解答一般常见问题</div>
        </div>
      </a>
    </li>
  </ul>
</div>
</div>
<link rel="stylesheet" href="//at.alicdn.com/t/font_537271_bahr30u4j38.css"><footer class="footer">
  <div class="footer-container">
      <div class="footer-top clearfix">
          <div class="footer-link">
                                  <dl>
                      <dt>联系与支持</dt>
                                                  
                              <dd><a href="https://www.juhe.cn/contact#section4" class="click-report-log"
                                     log-data="area=300001&index_id=3000034&tab=14 "
                                     target="_blank"
                                     rel="noopener noreferrer">400-882-7715</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/contact" class="click-report-log"
                                     log-data="area=300001&index_id=300003t&tab=1t "
                                     target="_blank"
                                     rel="noopener noreferrer">售前咨询</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/contact#section2" class="click-report-log"
                                     log-data="area=300001&index_id=3000032&tab=12 "
                                     target="_blank"
                                     rel="noopener noreferrer">客服&售后</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/qa" class="click-report-log"
                                     log-data="area=300001&index_id=300008"
                                     target="_blank"
                                     rel="noopener noreferrer">常见问题</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/workOrder" class="click-report-log"
                                     log-data="area=300001&index_id=300009"
                                     target="_blank"
                                     rel="noopener noreferrer">工单后台</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/complaints" class="click-report-log"
                                     log-data="area=300001&index_id=300010"
                                     target="_blank"
                                     rel="noopener noreferrer">投诉与建议</a></dd>
                                                                      </dl>
                                  <dl>
                      <dt>关于聚合</dt>
                                                  
                              <dd><a href="https://www.juhe.cn/links" class="click-report-log"
                                     log-data="area=300001&index_id=300012"
                                     target="_blank"
                                     rel="noopener noreferrer">合作伙伴</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/legal" class="click-report-log"
                                     log-data="area=300001&index_id=300013"
                                     target="_blank"
                                     rel="noopener noreferrer">服务条款</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/privacy" class="click-report-log"
                                     log-data="area=300001&index_id=300014"
                                     target="_blank"
                                     rel="noopener noreferrer">隐私政策</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/contact#section3" class="click-report-log"
                                     log-data="area=300001&index_id=3000033&tab=13 "
                                     target="_blank"
                                     rel="noopener noreferrer">市场合作</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/about" class="click-report-log"
                                     log-data="area=300001&index_id=300016"
                                     target="_blank"
                                     rel="noopener noreferrer">聚合简介</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/about/business" class="click-report-log"
                                     log-data="area=300001&index_id=300017"
                                     target="_blank"
                                     rel="noopener noreferrer">业务介绍</a></dd>
                                                                      </dl>
                                  <dl>
                      <dt>快速入口</dt>
                                                  
                              <dd><a href="https://www.juhe.cn/docs" class="click-report-log"
                                     log-data="area=300001&index_id=210000"
                                     target="_blank"
                                     rel="noopener noreferrer">API数据</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/vip" class="click-report-log"
                                     log-data="area=300001&index_id=300005"
                                     target="_blank"
                                     rel="noopener noreferrer">黑钻会员</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/superman" class="click-report-log"
                                     log-data="area=300001&index_id=300006"
                                     target="_blank"
                                     rel="noopener noreferrer">聚合超人</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/news/listview" class="click-report-log"
                                     log-data="area=300001&index_id=400000"
                                     target="_blank"
                                     rel="noopener noreferrer">新闻动态</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/contact" class="click-report-log"
                                     log-data="area=300001&index_id=300003t&tab=1t "
                                     target="_blank"
                                     rel="noopener noreferrer">联系我们</a></dd>
                                                                              
                              <dd><a href="https://www.lagou.com/gongsi/j11021.html" class="click-report-log"
                                     log-data="area=300001&index_id=300015"
                                     target="_blank"
                                     rel="noopener noreferrer">加入我们</a></dd>
                                                                      </dl>
                                  <dl>
                      <dt>产品服务</dt>
                                                  
                              <dd><a href="https://recharge.juhe.cn" class="click-report-log"
                                     log-data="area=300001&index_id=310002"
                                     target="_blank"
                                     rel="noopener noreferrer">在线批量充值服务</a></dd>
                                                                              
                              <dd><a href="https://activity.juhe.cn/exchange/index" class="click-report-log"
                                     log-data="area=300001&index_id=310003"
                                     target="_blank"
                                     rel="noopener noreferrer">聚合交易所</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/cellmap/gsm" class="click-report-log"
                                     log-data="area=300001&index_id=310004"
                                     target="_blank"
                                     rel="noopener noreferrer">基站定位</a></dd>
                                                                              
                              <dd><a href="https://www.juhe.cn/box" class="click-report-log"
                                     log-data="area=300001&index_id=310005"
                                     target="_blank"
                                     rel="noopener noreferrer">聚盒子</a></dd>
                       </dl>
<dl> <dt>解决方案</dt> <dd><a href="https://zhongtai.juhe.cn/" class="click-report-log" log-data="area=300001&amp;index_id=0" target="_blank" rel="noopener noreferrer">聚合：数字中台</a></dd> <dd><a href="https://tianqu.juhe.cn/" class="click-report-log" log-data="area=300001&amp;index_id=310011" target="_blank" rel="noopener noreferrer">天渠：外部数据管理</a></dd> <dd><a href="https://juhewin.com/" class="click-report-log" log-data="area=300001&amp;index_id=310012" target="_blank" rel="noopener noreferrer">有赢：助力企业营销</a></dd> </dl>
                          </div>
          <div class="footer-wechat">
              <p class="wechat-title">微信公众号</p>
              <p class="wechat-name">juhe_cn</p>
              <p class="wechat-pic"></p>
          </div>
      </div>
      <div class="footer-bottom clearfix"><div class="footer-bottom-left"><a href="http://www.jsdsgsxt.gov.cn/mbm/entweb/elec/certView.shtml?siteId=301146c087f2499ca507bfa91ab143ec" target="_blank" rel="noopener noreferrer"> <span class="footer-pic1"></span> </a> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002001776" target="_blank" rel="noopener noreferrer"> <span class="footer-pic2"></span> <span>苏公网安备 32059002001776号</span> </a> <span class="footer-license">增值电信业务经营许可证：苏B2-20140496</span> <a class="footer-icp" href="http://www.beian.miit.gov.cn" target="_blank" rel="noopener noreferrer"> <span>苏ICP备14006450号-3</span> </a></div><div class="footer-bottom-right"><span>天聚地合（苏州）数据股份有限公司©版权所有</span></div></div>

  </div>
</footer>
<div class="footer-help">
  <div class="footer-help-btn">
      <i class="iconfont icon-lianxizixun"></i>
      <span>联系</span>
      <span class="dot"></span>
      <span>咨询</span>
  </div>
  <div class="footer-help-top">
      <i class="iconfont icon-fanhuidingbu"></i>
      <!--[if lt IE 9]>
      <span>顶部</span>
      <![endif]-->
  </div>
  <div class="footer-help-container">
      <ul class="help-list">
          <li>
              <a class="clearfix click-report-log"
                 log-data="area=400001&index_id=300003&action_type=11"
                 href="https://www.juhe.cn/contact" target="_blank" rel="noopener noreferrer">
                  <div class="help-icon">
                      <i class="iconfont icon-lianxidianhua"></i>
                  </div>
                  <div class="help-text">
                      <div class="help-title">联系电话</div>
                      <div class="help-phone help-contact-phone">                                400-882-7715 </div>
                  </div>
              </a>
          </li>
          <li>
              <a class="clearfix click-report-log"
                 log-data="area=400001&index_id=300016&action_type=11"
                 href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDA3NjA2NV80ODI3NzdfODAwMDc2MDY1XzJf"
                 target="_blank" rel="noopener noreferrer">
                  <div class="help-icon">
                      <i class="iconfont icon-zaixianzixun"></i>
                  </div>
                  <div class="help-text">
                      <div class="help-title">在线咨询</div>
                      <div class="help-desc">QQ在线响应及时</div>
                  </div>
              </a>
          </li>
          <li>
              <a class="clearfix click-report-log"
                 log-data="area=400001&index_id=300009&action_type=11"
                 href="https://www.juhe.cn/workOrder" target="_blank" rel="noopener noreferrer">
                  <div class="help-icon">
                      <i class="iconfont icon-gongdanguanli"></i>
                  </div>
                  <div class="help-text">
                      <div class="help-title">工单管理</div>
                      <div class="help-desc">专业解答产品疑问</div>
                  </div>
              </a>
          </li>
          <li>
              <a class="clearfix click-report-log"
                 log-data="area=400001&index_id=300008&action_type=11"
                 href="https://www.juhe.cn/qa" target="_blank" rel="noopener noreferrer">
                  <div class="help-icon">
                      <i class="iconfont icon-changjianwenti"></i>
                  </div>
                  <div class="help-text">
                      <div class="help-title">常见问题</div>
                      <div class="help-desc">解答一般常见问题</div>
                  </div>
              </a>
          </li>
      </ul>
  </div>
</div>
<script src="https://juhecdn.oss-cn-hangzhou.aliyuncs.com/jquery/jquery.min.js" type="text/javascript" charset="utf-8"></script>
<script>
  var siteHost = "https://www.juhe.cn";
  var _token = "7PEHBy0pfs5zzbn6N7GpFPA2wYGY8j5J08nbZHsr";
  var loginState = 0;

  function throttle(e) {
      var t = !0;
      return function () {
          t && (t = !1, setTimeout(function () {
              e.apply(this, arguments), t = !0
          }, 100))
      }
  }

  $(document).ready(function () {
      var e = null;

      $(".footer-help-btn").mouseenter(function () {
          clearTimeout(e), $(".footer-help-container").fadeIn(150)
      }).mouseleave(function () {
          e = setTimeout(function () {
              $(".footer-help-container").fadeOut(150)
          }, 200)
      })
      $(".footer-help-container").mouseenter(function () {
          clearTimeout(e)
      }).mouseleave(function () {
          e = setTimeout(function () {
              $(".footer-help-container").fadeOut(150)
          }, 200)
      })
      $(".footer-help-top").click(function () {
          $(window).scrollTop(0)
      })
      $(window).on("scroll", throttle(function () {
          $(window).scrollTop() > 500 ? $(".footer-help-top").fadeIn(150) : $(".footer-help-top").fadeOut(150)
      }))
  });
</script>`;
